export const NEW_APP_DEFINITION = { version: '1.0.0' };
